export default __webpack_public_path__ + "static/media/A6ED47DC-A01C-41C3-B0F7-19D365A61BF0_1_105_c.ca3cb73a.jpeg";